

export const Service = ({...props}) => {
  return (
    <div className="grid grid-cols-[1fr_2fr]">
      <props.icon className="size-20"/>
      <div>
        <h2 className="font-semibold text-primary">{props.title}</h2>
        <p className="text-xs text-gray-800">{props.description}</p>
      </div>
    </div>
  )
}
